import type { ReactElement } from 'react';
import { AddNewAccount } from './AddNewAccount';
import { Chartofaccounts } from './Chartofaccounts';
import { Limitedcompany } from './Limitedcompany';
import { LimitedcompanyFRS102 } from './LimitedcompanyFRS102';
import { LimitedcompanyFRS105 } from './LimitedcompanyFRS105';
import { Llp } from './Llp';
import { Partnership } from './Partnership';
import { Soletrader } from './Soletrader';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/settings/chart-accounts': <Chartofaccounts />,
  '/home/settings/addnewaccount': <AddNewAccount />,
  '/home/settings/limited-company': <Limitedcompany />,
  '/home/settings/limited-company-FRS102': <LimitedcompanyFRS102 />,
  '/home/settings/limited-company-FRS105': <LimitedcompanyFRS105 />,
  '/home/settings/llp': <Llp />,
  '/home/settings/partnership': <Partnership />,
  '/home/settings/sole-trader': <Soletrader />,
};
